document.addEventListener('DOMContentLoaded', () => {
  const $root = $('.affiliates')

  if (!$root.length) {
    return
  }

  $root.on('click', '.payout-table__submit', function () {
    const payout = $(this).data('payout')

    if (!confirm('Do you really want to make a payout for this affiliate?')) {
      return
    }

    if (+payout.revenue > 0) {
      $(this).removeClass('payout-table__submit')
      $.post('/admin/payouts', { payout }).done(res => {
        $(this).removeClass('payout-table__status_pending')
        $(this).addClass('payout-table__status_paid')
        $(this).text('Paid')
      })
    }
  })

  $root.find('.visitors-chart').each(function (i) {
    const data = JSON.parse($(this).attr('data-metrics'))
    if (data.length > 0) {
      drawChart($(this).find('canvas').get()[0], data, 'Visitors', '#5b68bd')
    }
  })
  $root.find('.new-paid-chart').each(function (i) {
    const data = JSON.parse($(this).attr('data-metrics'))
    if (data.length > 0) {
      drawChart($(this).find('canvas').get()[0], data, 'New paid', '#5b68bd')
    }
  })

  function drawChart(el, data, label, color) {}
})
